import { Button, Modal } from "reactstrap";
import crossIcon from "@src/assets/images/vyrill/icons/cross_icon.png";
import { useDispatch, useSelector } from "react-redux";
import {
  updateCampaignFields,
  updateCampaignState as updateCreateCampaignState,
} from "../../../CreateCampaign/CampaignActions";
import { updateCampaignState } from "../../VideoActions";
import { useNavigate } from "react-router-dom";

const QrCodeModal = ({ open, handleCloseQr }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const videoData = useSelector(
    (state) => state.videoData.campaign_details_list
  );
  const campaignData = videoData?.campaign_details;
  const handleQrClick = (campaignId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("id", campaignId);
    navigate("/create_campaign?" + queryParams.toString());
    dispatch(updateCreateCampaignState({ activeStep: 5 }));
    dispatch(
      updateCampaignState({ showCampaignStep: true, showCampaignDetail: false })
    );
    dispatch(
      updateCampaignFields({
        banner_share_url: "",
        banner_with_qr: "",
      })
    );
  };
  return (
    <Modal isOpen={open} contentClassName="custom-campaign-detail-modal">
      <div
        role="button"
        style={{ position: "absolute", right: "25px", top: "25px" }}
        onClick={handleCloseQr}
      >
        <img src={crossIcon} />
      </div>
      <div className="form-field-label">QR Code</div>
      <div className="d-flex justify-content-center qr-text">
        Participants can scan this QR code and easily upload their video to
        participate in your campaign.
      </div>
      <div className="d-flex justify-content-center mt-4">
        <img
          src={
            require(`@src/assets/images/vyrill/campaign-tool/qrimage.png`)
              .default
          }
          alt=""
          width={421}
        />
      </div>
      <div className="d-flex justify-content-center mt-4">
        <Button
          style={{
            width: "247px",
            height: "56px",
          }}
          size="lg"
          color="primary"
          onClick={() => handleQrClick(campaignData?._id)}
        >
          Generate QR Code
        </Button>
      </div>
    </Modal>
  );
};

export default QrCodeModal;
